import React from "react";
import { createRoot } from "react-dom/client";
import "core-js/stable";
import "regenerator-runtime/runtime";
import "global.scss";
import Root from "AppRoot";
import "utils/login";
import * as Sentry from "@sentry/react";
import env from "utils/environment";
import { datadogRum } from '@datadog/browser-rum';

class GreenlineApp {
    constructor({rootPath, environment}) {
        env.setEnvironment(environment);
        this.rootPath = rootPath || "";
        const environmentName = env.environment.ENVIRONMENT_NAME;
        
        // Validate required Datadog environment variables
        const requiredDatadogVars = [
            'DATADOG_APPLICATION_ID',
            'DATADOG_CLIENT_TOKEN', 
            'DATADOG_SITE',
            'DATADOG_SERVICE'
        ];
        
        const missingVars = requiredDatadogVars.filter(varName => !env.environment[varName]);
        
        if (missingVars.length > 0) {
            console.warn('Datadog initialization skipped - missing environment variables:', missingVars);
        } else {
            try {
                datadogRum.init({
                    applicationId: env.environment.DATADOG_APPLICATION_ID,
                    clientToken: env.environment.DATADOG_CLIENT_TOKEN,
                    site: env.environment.DATADOG_SITE,
                    service: env.environment.DATADOG_SERVICE,
                    env: env.environment.ENVIRONMENT_NAME,
                    allowedTracingOrigins: env.environment.DATADOG_ORIGINS || [],
                    version: '1.0.0',
                    traceSampleRate: 100,
                    sampleRate: 100,
                    sessionSampleRate: 100,
                    sessionReplaySampleRate: 100,
                    defaultPrivacyLevel: 'mask-user-input',
                    trackInteractions: true,
                    trackResources: true,
                    trackLongTasks: true,
                    startSessionReplayRecordingManually: false,
                    trackFrustrations: true,
                    trackViewsManually: false,
                    enableExperimentalFeatures: ['clickmap']
                });

                // Set user data if available
                if (window.user && window.user.id) {
                    datadogRum.setUser({
                        id: window.user.id,
                        name: window.user.name || '',
                        roles: window.user.roles || []
                    });
                }
                
                datadogRum.startSessionReplayRecording();
            } catch (error) {
                console.error('Failed to initialize Datadog RUM:', error);
            }
        }

        if (environmentName !== "greenline-dev") {
            Sentry.init({
                dsn: "https://1ed215243c9a44fb821f9d8d5371db1c@o973525.ingest.sentry.io/5925002",
                environment: environmentName,
                debug: false,
                attachStacktrace: true,
                ignoreErrors: [
                    "ResizeObserver loop limit exceeded",
                    "No matching state found in storage",
                    "Unauthorized",
                    "TypeError: Cannot read properties of null (reading 'zoom')",
                ],
            });
        }
    }

    render() {
        const container = document.getElementById("app");
        const root = createRoot(container);
        root.render(
            <Root
                rootPath={this.rootPath}
                environmentName={env.environment.ENVIRONMENT_NAME}
            />
        );
    }
}

__webpack_public_path__ = window.GL_ENV?.staticUrl || "";
window.GreenlineApp = GreenlineApp;
